<template>
    <div id="tiaozhuan">
        <div class="center">
            <h3>由于篇幅限制，未完待续！</h3>
            <h4>使用微信扫描下方二维码，回复书名 <span>《{{bookInfo.title}}》</span></h4>
            <h4>马上阅读全文</h4>
            <img :src="getImg" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "Tiaozhuan",
        data(){
            return {
                bookInfo : {},
                wechatInfo : {}
            }
        },
        computed : {
            getImg(){
                return 'https://open.weixin.qq.com/qr/code?username='+this.wechatInfo.username;
            }
        },
        methods : {
            getBookInfo(){
                this.axios.post('/api/book/bookinfo',{
                    bookid : this.$route.params.wid
                }).then(r => {
                    let data = r.data;
                    if(data.code == 0){
                        this.$message.error(data.msg);

                    }else{
                        this.bookInfo = data.data;
                    }
                })
            },
            getWechatInfo(){
                this.axios.post('/api/wechat/getWechatInfo').then(r =>{
                    let data = r.data;
                    if(data.code){
                        this.wechatInfo = data.data;
                        console.log(this.wechatInfo);
                    }
                })
            },
        },
        created(){
            this.getBookInfo();
            this.getWechatInfo();
        }
    }
</script>

<style lang="less">
#tiaozhuan{
    .center{width: 400px;margin: 200px auto;text-align: center;color: #333;}
    h3{text-align: center;color: orangered;font-size: 22px;}
    h4{text-align: center;}
    span{color: red;}
    img{width: 300px;}
}
</style>
